import { render, staticRenderFns } from "./processRelationPicture.vue?vue&type=template&id=1891d6d4"
import script from "./processRelationPicture.vue?vue&type=script&lang=js"
export * from "./processRelationPicture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1891d6d4')) {
      api.createRecord('1891d6d4', component.options)
    } else {
      api.reload('1891d6d4', component.options)
    }
    module.hot.accept("./processRelationPicture.vue?vue&type=template&id=1891d6d4", function () {
      api.rerender('1891d6d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/iim/processRelationPicture.vue"
export default component.exports